import {
  createTheme,
  responsiveFontSizes,
  rgbToHex,
} from '@material-ui/core/styles';

const WHITE = '#ffffff';
const GREY = '#858073';

let adaTheme = createTheme({
  palette: {
    primary: {
      main: '#403CFA',
    },
    secondary: {
      main: '#01C1D8',
      contrastText: WHITE,
    },
    state: {
      public: '#0F9D58',
      private: '#F4B400',
      draft: '#ccc',
    },
    text: {
      // primary: rgbToHex('rgba(200, 200, 200, 255)'),
      // secondary: rgbToHex('rgba(200, 200, 200, 150)'),
    },
  },
  typography: {
    fontFamily: ['Akkurat', 'system-ui', 'sans-serif'],
    subtitle1: {
      fontSize: 16,
      fontWeight: 500,
    },
  },
});

// adaTheme = responsiveFontSizes(adaTheme)

adaTheme.overrides = {
  MuiButton: {
    root: {
      color: adaTheme.palette.grey[500],
    },
  },
  MuiTooltip: {
    arrow: {
      color: 'rgba(0, 0, 0, 0.9)',
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      ...adaTheme.typography.caption,
    },
  },
  MuiTableSortLabel: {
    icon: {
      color: `${adaTheme.palette.primary.light}`,
    },
    root: {
      '&:hover': {
        color: `${adaTheme.palette.primary.light}`,
        '& $icon': {
          color: `${adaTheme.palette.primary.light}`,
          opacity: 1,
        },
      },
      '&:hover&$active': {
        color: `${adaTheme.palette.primary.light}`,
      },
      '&$active': {
        color: `${adaTheme.palette.primary.main}`,
      },
      '&:hover&$active&$root&$active': {
        '& $icon': {
          color: `${adaTheme.palette.primary.light}`,
        },
      },
      '&$active&$root&$active': {
        '& $icon': {
          color: `${adaTheme.palette.primary.main}`,
        },
      },
    },
  },
};

export default adaTheme;
